<script setup>
defineProps({ scene: { type: Object, required: true } })
</script>

<template>
  <div class="lesson-scene">
    <div class="scene-eyebrow">{{ scene.theme === 'science' ? 'QUAN SÁT, KIỂM CHỨNG & GIẢI THÍCH' : scene.theme === 'literature' ? 'ĐỌC, SUY NGHĨ & DIỄN ĐẠT' : scene.theme === 'english' ? 'DÙNG TIẾNG ANH TRONG TÌNH HUỐNG' : scene.theme === 'geometry' ? 'QUAN SÁT & THIẾT KẾ' : scene.theme === 'data' ? 'ĐIỀU TRA & RA QUYẾT ĐỊNH' : 'TOÁN TRONG ĐỜI SỐNG' }}</div>
    <dl class="scene-facts">
      <div v-for="(fact, index) in scene.facts" :key="index"><dt>{{ fact.label }}</dt><dd>{{ fact.value }}</dd></div>
    </dl>
    <p class="scene-question"><span aria-hidden="true">?</span>{{ scene.question }}</p>
    <p class="scene-invitation">{{ scene.invitation || 'Em thử hình dung tình huống. Các chặng bên dưới sẽ giải thích cách dùng toán để trả lời.' }}</p>
  </div>
</template>
